module.exports = __webpack_public_path__ + "img/web-benoa-square.2202bcdd.jpg";